// @flow strict

import styled from 'styled-components';

export const RawStyledPageFooter = styled.footer`
  margin-top: 64px;
`;

export const StyledPageFooter = RawStyledPageFooter;
